module.exports = __webpack_public_path__ + "img/25-green.b31a619b.svg";